import { getLocations, getOperators } from "@/components/charts/oil/lib/api";
const types = {
  well: 'Oil Well',
  lga: 'Local Government Authority',
  state: 'State',
  field: 'Oil Field',
  operator: 'Operator'
};
export default {
  async aLoadLocations({ state, commit }) {
    commit('mSetLoading', true);
    const response = await getLocations();
    const operatorResponse = await getOperators();
    const results = response.data.results;
    const list = results.filter((data) => data.latitude && data.longitude);
    state.locations = [...list];
    const locationSearchList = results.map((item) => {
      return {
        name: item.location,
        code: item.code,
        type: types[item.type] ? types[item.type] : item.type,
      }
    });
    const operatorSearchList = operatorResponse.data.results.map((item) => {
      return {
        name: item.name,
        code: item.code,
        type: 'Operator',
      }
    });

    state.searchList = [...locationSearchList, ...operatorSearchList];
    commit('mSetLoading', false);
    commit('mSetLoaded', true);


  }
};
